import React, { useContext, useEffect, useState } from "react";
import HeaderWithButton from "../Utility/HeaderWithButton";
import LeadTaskList from "./LeadTaskList";
import axios from "axios";
import { toast } from "react-toastify";
import { Dialog } from "@headlessui/react";
import { XMarkIcon, PencilSquareIcon } from "@heroicons/react/24/outline";
import Select from "react-select";
import { Country, State, City } from "country-state-city";
import { useLocation } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { use } from "react";
import { DataContext } from "../../helper/HelperOne";
import TopStats from "../Utility/TopStats";
import { useNavigate } from "react-router-dom";
import { EllipsisVerticalIcon } from "lucide-react";
import LabelTopView from "../Utility/LabelTopView";
import TopFilters from "../Utility/TopFilters";
import { DatabaseBackupIcon } from "lucide-react";
import UpdateConfirmation from "../Utility/UpdateConfirmation";

function LeadTaskCreate() {
  const location = useLocation();
  const { id_crypt, showForm } = location.state || {};
  const { leadIdCrypt, leadId } = location.state || {};
  const [leadIdCryptForTask, setLeadIdCryptForTask] = useState(leadIdCrypt);

  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));
  const taskPermission = user?.task_role_based_access?.some(
    (access) => access.label_id == 2 && access.label_value != 0
  );

  const userForEdit = JSON.parse(localStorage.getItem("user"));
  const taskPermissionForEdit = userForEdit?.task_role_based_access?.some(
    (access) => access.label_id == 3 && access.label_value != 0
  );

  const toolbarOptions = [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["bold", "italic", "underline", "strike"],
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
    ["blockquote", "code-block"],
    ["link", "image"],
    ["clean"],
  ];
  const { searchData } = useContext(DataContext);
  const [isEditing, setIsEditing] = useState(false);
  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [saveBtnOpen, setSaveBtnOpen] = useState(false);

  const [editTaskIdCrypt, setEditTaskIdCrypt] = useState("");
  // const location = useLocation();
  // const { leadIdCrypty, leadId } = location.state || {};
  const [leadType, setLeadType] = useState("general");
  const [openDialogBoxForLead, setopenDialogBoxForLead] = useState(false);
  const [taskStatusList, setTaskStatusList] = useState([]);
  const [saveBtn, setSaveBtn] = useState("save");
  const [editId, setEditId] = useState("");
  const [loading, setLoading] = useState(false);
  const [employeesList, setEmployeesList] = useState([]);
  const [leadAllDatas, setLeadAllDatas] = useState([]);
  const [allPaginationTaskDatas, setAllPaginationTaskDatas] = useState([]);
  const [allTaskDatas, setAllTaskDatas] = useState([]);
  const [taskCreateDatas, setTaskCreateDatas] = useState([]);
  const [priority, setPriority] = useState([]);
  const [taskBasedOnLead, setTaskBasedOnLead] = useState([]);
  const [leadTaskDetails, setLeadTaskDetails] = useState({
    lead_id: "",
    task_type: "",
    leads: "",
    start_date: "",
    task_name: "",
    end_date: "",
    priority: "",
    task_members: [],
    task_description: "",
    task_status: "",
  });
  const [leadTaskFile, setLeadTaskFile] = useState([]);
  const [taskImage, setTaskImage] = useState(null);
  const [filterParams, setFilterParams] = useState("");

  const [page, setPage] = useState(1);
  const [requiredFields, setRequiredFields] = useState({
    task_type: "",
    leads: "",
    start_date: "",
    end_date: "",
    task_name: "",
    task_status: "",
    priority: "",
    task_members: [],
    // task_files: [],
    task_description: "",
  });

  const [filterData, setFilterData] = useState({
    priority: "",
    task_members: "",
    task_status: "",
  });

  const fetchLeadTaskDatas = async (page = 1, searchData = "") => {
    try {
      const leadUrl = searchData
        ? `public/api/admin/tasks/pagination?page=${page}&search=${encodeURIComponent(
            searchData
          )}`
        : `public/api/admin/tasks/pagination?page=${page}`;

      const [
        priorityResponse,
        employeeResponse,
        taskPaginationResponse,
        taskResponse,
        leadResponse,
        taskStatusResponse,
      ] = await Promise.all([
        axios.get(`public/api/admin/task/priority`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }),
        axios.get(`public/api/admin/employees`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }),
        axios.get(leadUrl, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }),
        axios.get(`public/api/admin/tasks`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }),
        axios.get(`public/api/admin/lead`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }),
        axios.get(`public/api/admin/taskstatus`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }),
      ]);

      setPriority(priorityResponse.data.task_priority);
      setEmployeesList(employeeResponse.data.employee);
      setAllTaskDatas(taskPaginationResponse.data.task);
      setAllPaginationTaskDatas(taskPaginationResponse.data.task);
      setLeadAllDatas(leadResponse.data.lead);
      setTaskStatusList(taskStatusResponse.data.taskstatus);
    } catch (error) {
      console.error("Error fetching lead data: ", error);
    }
  };

  useEffect(() => {
    fetchLeadTaskDatas(page, searchData);
  }, [searchData, page]);

  const fetchLeadDatasForTask = async (page = 1, queryParams = "") => {
    try {
      // const leadUrl = `public/api/admin/lead/edit/${leadIdCrypt}?page=${page}${
      //   searchData ? `&search=${encodeURIComponent(searchData)}` : ""
      // }${queryParams ? `&${queryParams}` : ""}`;

      const leadUrl = `public/api/admin/lead/edit/${leadIdCrypt}?page=${page}${
        queryParams ? `&${queryParams}` : ""
      }${searchData ? `&search=${encodeURIComponent(searchData)}` : ""}`;
      

      const response = await axios.get(leadUrl, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });


      

      setTaskBasedOnLead(response.data);

      setLeadTaskDetails((prevDetails) => ({
        ...prevDetails,
        leads: response.data.lead?.id,
        lead_id: response.data.lead?.id,
        task_type: 2,
        task_members: response?.data?.lead?.lead_employee?.map(
          (item) => item.id
        ),
      }));

     
      setLeadType("lead");
      setEmployeesList(response.data.leads.lead_employee);
    } catch (error) {
      console.error("Error fetching lead data: ", error);
    }
  };

  useEffect(() => {
    if (leadIdCryptForTask) {
      fetchLeadDatasForTask();
    }
  }, [leadIdCryptForTask, searchData]);

  const fields = [
    // {
    //   name: "priority",
    //   type: "text",
    //   placeholder: "Priority",
    //   componentType: "select",
    //   options: [
    //     ...new Map(
    //       allPaginationTaskDatas?.data
    //         ?.filter((task) => task.priority_name) // Ensure priority_name exists
    //         ?.map((task) => [
    //           task.priority_name.id, // Use ID as the map key to ensure uniqueness
    //           {
    //             value: String(task.priority_name.id),
    //             label: task.priority_name.name
    //           }
    //         ])
    //     ).values(),
    //   ],
    // }
    {
      name: "priority",
      type: "text",
      placeholder: "Priority",
      componentType: "select",
      options: [
        ...new Map(
          (taskBasedOnLead?.tasks?.data || []) // Ensure tasks.data exists
            .filter((task) => task.priority_name && task.priority_name.id) // Ensure priority_name is valid
            .map((task) => [
              task.priority_name.id, // Use ID as the map key for uniqueness
              {
                value: String(task.priority_name.id),
                label: task.priority_name.name,
              },
            ])
        ).values(),
      ],
    },
    {
      name: "task_members",
      type: "text",
      placeholder: "Task Members",
      componentType: "select",
      options: [
        ...new Map(
          taskBasedOnLead?.tasks?.data?.flatMap(
            (task) =>
              task.task_member?.map((member) => [
                member.id, // Use only `member.id` for uniqueness
                {
                  value: member.id,
                  label: member.name,
                },
              ]) || []
          )
        ).values(),
      ],
    },
    {
      name: "task_status",
      type: "text",
      placeholder: "Task Status",
      componentType: "select",
      options:
        Array.from(
          new Map(
            taskBasedOnLead?.tasks?.data
              ?.filter((task) => task.task_status_name) // Filter to ensure valid data
              ?.map((task) => [
                task.task_status_name.id, // Use `id` as the key to ensure uniqueness
                {
                  value: task.task_status_name.id,
                  label: task.task_status_name.name,
                },
              ])
          ).values() // Extract unique entries from the map
        ) || [],
    },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;


    setLeadTaskDetails((prev) => ({
      ...prev,
      [name]: value,
    }));

    // setFilterData({ ...filterData, [e.target.name]: e.target.value });
  };

  const handleChangeFilterChange = (e) => {
  

    setFilterData({ ...filterData, [e.target.name]: e.target.value });
  };

  const handleFilter = async () => {
 
    
    try {
      const queryParams = new URLSearchParams();

      if (filterData.task_type) {
        queryParams.append("task_type", filterData.task_type);
      }

      if (filterData.task_status) {
        queryParams.append("task_status", filterData.task_status);
      }

      if (filterData.priority) {
        queryParams.append("priority", filterData.priority);
      }

      if (filterData.task_members) {
        queryParams.append("task_members", filterData.task_members);
      }

      if (filterData.leads) {
        queryParams.append("leads", filterData.leads);
      }

      // Store filter query for later use
      setFilterParams(queryParams.toString());


      

      // Call fetch function with the first page and applied filters
      await fetchLeadDatasForTask(1, queryParams.toString());
    } catch (error) {
      console.error("Error applying filters:", error);
    }
  };

  const handleReset = async () => {
    setFilterData({ task_type: "", leads: "", priority: "", task_members: "" });
    await fetchLeadDatasForTask();
  };

  const handleAddLeadTask = async () => {
    setLoading(true);
    setSaveBtn("save");
    setSaveBtnOpen(true);
    setIsEditing(false);
    setLeadType("");
    setopenDialogBoxForLead(true);
    try {
      await fetchLeadDatasForTask();
      // setLeadTaskDetails({
      //   task_type: "",
      //   leads: "",
      //   start_date: "",
      //   end_date: "",
      //   priority: "",
      //   task_name: "",
      //   task_status: "",
      //   task_members: [],

      //   task_description: "",
      // });
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };



  const handleChangeForLeadTaskImage = (e) => {
    const file = e.target.files[0];

    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const allowedTypes = ["pdf", "jpeg", "jpg", "png", "docx"];

      if (!allowedTypes.includes(fileExtension)) {
        toast.error("Invalid file type. Please upload a valid file.");
        return;
      }

      setTaskImage(file); // Store the file object directly
    } else {
      setTaskImage(null); // Clear if no file is selected
    }
  };

  const handleChangeForLeadTask = (event) => {
    const { name, value, files } = event.target;

   

    if (name === "task_type") {
      setLeadType(value == 2 ? "lead" : "general");
      setLeadTaskDetails((prevDetails) => ({
        ...prevDetails,
        lead_id: "",
      }));
    }
    if (name === "leads") {
      setLeadTaskDetails((prevDetails) => ({
        ...prevDetails,
        leads: value,
        lead_id: value,
      }));
    } else {
      setLeadTaskDetails((prevDetails) => ({
        ...prevDetails,
        [name]: value,
      }));
    }
  };



  const handleSubmitForLeadTask = async (e) => {
    e.preventDefault();

    // Remove <p> tags from task_description
    const strippedDescription = leadTaskDetails.task_description.replace(
      /<p[^>]*>|<\/p>/g,
      ""
    );

    try {
      const formData = new FormData();

      formData.append("lead_id", leadTaskDetails.lead_id);
      formData.append("task_type", leadTaskDetails.task_type);
      formData.append("leads", leadTaskDetails.leads);
      formData.append("task_name", leadTaskDetails.task_name);
      formData.append("start_date", leadTaskDetails.start_date);
      formData.append("end_date", leadTaskDetails.end_date);
      formData.append("priority", leadTaskDetails.priority);
      formData.append("task_status", leadTaskDetails.task_status);
      formData.append("task_description", strippedDescription);

      // Append task members as a JSON string (if array-based)
      formData.append(
        "task_members",
        JSON.stringify(leadTaskDetails.task_members)
      );

      // Include file upload logic if needed
      if (taskImage) {
        formData.append("taskImage", taskImage); // Add file to formData
      }

      const response = await axios.post(
        "public/api/admin/tasks/store",
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response) {
        toast.success(response.data.message, {
          autoClose: 1000, // Closes the toast in 2 seconds
        });
        setopenDialogBoxForLead(false);
        await fetchLeadDatasForTask();
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };

  const handleEditForLeadTask = async (id_crypt) => {
    setIsEditing(false);
    setSaveBtnOpen(true);
    setSaveBtn("update");
    toast.success("Now You Can Edit This Lead Task");
    try {
      const response = await axios.get(
        `public/api/admin/tasks/edit/${id_crypt}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      const task = response.data.task;
   

      if (task.task_type === "2") {
        setLeadType("lead");
      }

      setLeadTaskDetails({
        task_type: 2,
        lead_id: task.lead_name?.id, // if applicable
        leads: task.lead_name?.id, // adjust if needed
        task_name: task.task_name,
        task_status: task.task_status,
        task_members: task.task_member.map((item) => item.id),
        priority: task.priority,
        start_date: task.start_date,
        end_date: task.end_date,
        task_description: task.task_description,
      });
      setLeadTaskFile(response?.data?.task?.task_files);
    } catch (error) {
      // toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateForLeadTask = async (e) => {
    e.preventDefault();

    // Remove <p> tags from task_description
    const strippedDescription = leadTaskDetails.task_description.replace(
      /<p[^>]*>|<\/p>/g,
      ""
    );

    try {
      const formData = new FormData();

      formData.append("lead_id", leadTaskDetails.lead_id);
      formData.append("task_type", leadTaskDetails.task_type);
      formData.append("leads", leadTaskDetails.leads);
      formData.append("task_name", leadTaskDetails.task_name);
      formData.append("start_date", leadTaskDetails.start_date);
      formData.append("end_date", leadTaskDetails.end_date);
      formData.append("priority", leadTaskDetails.priority);
      formData.append("task_status", leadTaskDetails.task_status);
      formData.append("task_description", strippedDescription);

      // Append task members as a JSON string (if array-based)
      formData.append(
        "task_members",
        JSON.stringify(leadTaskDetails.task_members)
      );

      // Include file upload logic if needed
      if (taskImage) {
        formData.append("taskImage", taskImage); // Add file to formData
      }

      const response = await axios.post(
        `public/api/admin/tasks/update/${editTaskIdCrypt}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response) {
        toast.success(response.data.message, { autoClose: 500 });
        setopenDialogBoxForLead(false);
        await fetchLeadDatasForTask();
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };

  const handleDialogClose = async () => {
    setLoading(true);
    try {
      await fetchLeadTaskDatas();
      setopenDialogBoxForLead(false);
      setLeadTaskDetails({
        start_date: "",
        end_date: "",
        priority: "",
        task_name: "",
        task_status: "",
        task_description: "",
      });
      // If showForm is true, reset to false and redirect to Dashboard
      if (showForm) {
        navigate("/crm/lead_dashboard"); // Redirect to Dashboard
      } else {
        navigate(location.pathname, {
          state: { ...location.state, showForm: false },
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const statsFieldNames = [
    {
      title: "Total Tasks",
      value: taskBasedOnLead?.totaltaskCounts,
      color: "blue",
      bg: "bg-blue-50",
      link: "/crm/employees",
    },
    {
      title: "Completed Tasks",
      value: taskBasedOnLead?.completedCounts,
      color: "green",
      bg: "bg-blue-50",
      link: "/crm/employees",
    },
    {
      title: "Pending Tasks",
      value: taskBasedOnLead?.pendingCounts,
      color: "red",
      bg: "bg-green-50",
      link: "/crm/employees/active",
    },
    {
      title: "In Progress Tasks",
      value: taskBasedOnLead?.inprogressCounts,
      color: "blue",
      bg: "bg-red-50",
      link: "/crm/employees/inactive",
    },
    {
      title: "Not Yet Started",
      value: taskBasedOnLead?.notyetstartedCounts,
      color: "green",
      bg: "bg-blue-50",
      link: "/crm/employees",
    },
  ];

  return (
    <>
      {loading ? (
        <div className="h-screen bg-white">
          <div className="flex justify-center items-center h-full">
            <img
              className="h-16 w-16"
              src="https://icons8.com/preloaders/preloaders/1488/Iphone-spinner-2.gif"
              alt="loader"
            />
          </div>
        </div>
      ) : (
        <>
          <button
            onClick={() => window.history.back()}
            className="px-4 py-2 sm:px-5 sm:py-2.5 bg-gray-500 text-white sm:text-xs text-xs font-semibold rounded-lg shadow-md transition-all duration-200 hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2"
          >
            ← Back
          </button>

          <LabelTopView label="Task Overview" icon={<DatabaseBackupIcon />} />

          <TopStats statsFieldNames={statsFieldNames} />

          <HeaderWithButton
            title="All Task "
            description="all lead task"
            buttonText="Lead Task"
            onButtonClick={handleAddLeadTask}
            showButton={taskPermission}
          />

          <TopFilters
            fields={fields}
            filterData={filterData}
            handleChange={handleChangeFilterChange}
            handleFilter={handleFilter}
            handleReset={handleReset}
          />

          <LeadTaskList
            setopenDialogBoxForLead={setopenDialogBoxForLead}
            setLeadTaskDetails={setLeadTaskDetails}
            setSaveBtn={setSaveBtn}
            setLoading={setLoading}
            allPaginationTaskDatas={allPaginationTaskDatas}
            allTaskDatas={allTaskDatas}
            setLeadTaskFile={setLeadTaskFile}
            setEditId={setEditId}
            setLeadType={setLeadType}
            fetchLeadTaskDatas={fetchLeadTaskDatas}
            setIsEditing={setIsEditing}
            setEditTaskIdCrypt={setEditTaskIdCrypt}
            setSaveBtnOpen={setSaveBtnOpen}
            id_crypt={id_crypt}
            showForm={showForm}
            taskBasedOnLead={taskBasedOnLead}
            setLeadIdCryptForTask={setLeadIdCryptForTask}
            fetchLeadDatasForTask={fetchLeadDatasForTask}
          />
          {openDialogBoxForLead && (
            <Dialog
              open={openDialogBoxForLead}
              onClose={() => {}}
              className="relative z-10"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

              <div className="fixed inset-0 z-10 overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                  <Dialog.Panel className="my-auto relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-full sm:w-full md:max-w-screen-sm lg:max-w-screen-xl h-full sm:h-auto max-h-[90vh] overflow-y-auto ">
                    <div
                      className="flex justify-between p-4 text-white sticky top-0"
                      style={{ backgroundColor: "#6366f1" }}
                    >
                      <h1 className="mx-auto sm:px-6 sm:mx-0 md:px-8 sm:text-lg font-medium mb-2 uppercase z-100">
                        Lead Management Task
                      </h1>
                      <div className="flex gap-2">
                        {taskPermissionForEdit && isEditing && (
                          <div className="relative">
                            <button
                              type="button"
                              className="inline-flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900"
                              aria-expanded={isOpenEdit}
                            >
                              <PencilSquareIcon
                                // onClick={() => setIsOpenEdit(!isOpenEdit)} // Toggle visibility
                                onClick={() => {
                                  handleEditForLeadTask(editTaskIdCrypt);
                                  setIsOpenEdit(false); // Close after clicking Edit
                                }}
                                className="h-6 w-6 cursor-pointer text-white"
                              />
                            </button>

                            {/* {isOpenEdit && (
                                <div className="absolute left-1/2 z-10 mt-5 flex w-screen max-w-min -translate-x-1/2 px-4">
                                  <div className="w-56 shrink rounded-xl bg-white p-4 text-sm/6 font-semibold text-gray-900 ring-1 shadow-lg ring-gray-900/5">
                                    <a
                                      href="#"
                                      className="block p-2 hover:text-indigo-600"
                                      onClick={() => {
                                        handleEditForLeadTask(editTaskIdCrypt);
                                        setIsOpenEdit(false); // Close after clicking Edit
                                      }}
                                    >
                                      Edit
                                    </a>
                                  </div>
                                </div>
                              )} */}
                          </div>
                        )}
                        <XMarkIcon
                          onClick={handleDialogClose}
                          className="h-6 w-6 cursor-pointer"
                        />
                      </div>
                    </div>
                    <div className="md:grid md:gap-6 p-4">
                      <div className="md:mt-0 md:col-span-2">
                        <form className="space-y-6 shadow-xl rounded">
                          <div className=" overflow-hidden">
                            <div className="p-6">
                              <div
                                className={`grid gap-6 ${
                                  leadType === "lead"
                                    ? "grid-cols-4 md:grid-cols-6 lg:grid-cols-8"
                                    : "grid-cols-3 md:grid-cols-4 lg:grid-cols-6"
                                }`}
                              >
                                {/* Lead ID - Hidden */}
                                <div className="col-span-6 sm:col-span-3 md:col-span-2 lg:col-span-2 hidden">
                                  <label
                                    htmlFor="lead_id"
                                    className="block text-sm font-medium text-gray-900"
                                  >
                                    LEAD ID
                                  </label>
                                  <input
                                    name="lead_id"
                                    value={leadTaskDetails?.lead_id || ""}
                                    onChange={handleChangeForLeadTask}
                                    className={`block w-full ${
                                      isEditing && "bg-gray-100"
                                    }  mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                    disabled={isEditing}
                                  />
                                </div>

                                {/* Task Type */}
                                <div className="col-span-6 sm:col-span-3 md:col-span-2 lg:col-span-2">
                                  <label
                                    htmlFor="task_type"
                                    className="block text-sm font-medium text-gray-900"
                                  >
                                    Task Type
                                  </label>
                                  <select
                                    name="task_type"
                                    value={leadTaskDetails?.task_type || ""}
                                    onChange={handleChangeForLeadTask}
                                    className={`block w-full bg-gray-200  mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                    disabled
                                  >
                                    <option value="" disabled>
                                      Select Task Type
                                    </option>
                                    <option value="1">General</option>
                                    <option value="2">Lead</option>
                                  </select>
                                </div>

                                {/* Leads - Conditionally Rendered */}
                                {leadType === "lead" && (
                                  <div className="col-span-6 sm:col-span-3 md:col-span-2 lg:col-span-2">
                                    <label
                                      htmlFor="leads"
                                      className="block text-sm font-medium text-gray-900"
                                    >
                                      LEADS
                                    </label>
                                    <Select
                                      name="leads"
                                      options={leadAllDatas?.map((lead) => ({
                                        value: lead.id,
                                        label: lead.name,
                                      }))}
                                      value={
                                        leadAllDatas
                                          ?.filter(
                                            (lead) =>
                                              lead.id === leadTaskDetails?.leads
                                          )
                                          ?.map((lead) => ({
                                            value: lead.id,
                                            label: lead.name,
                                          })) || null
                                      }
                                      onChange={(selectedOption) =>
                                        handleChangeForLeadTask({
                                          target: {
                                            name: "leads",
                                            value: selectedOption?.value,
                                          },
                                        })
                                      }
                                      className="w-full mt-2"
                                      isDisabled={true}
                                      classNamePrefix="select"
                                      placeholder="Select Lead"
                                    />
                                    {requiredFields.name && (
                                      <p className="mt-1 text-sm text-red-600">
                                        {requiredFields.name}
                                      </p>
                                    )}
                                  </div>
                                )}

                                {/* Task Name */}
                                <div className="col-span-6 sm:col-span-3 md:col-span-2 lg:col-span-2">
                                  <label
                                    htmlFor="task_name"
                                    className="block text-sm font-medium text-gray-900"
                                  >
                                    Task Name
                                  </label>
                                  <input
                                    name="task_name"
                                    value={leadTaskDetails?.task_name || ""}
                                    onChange={handleChangeForLeadTask}
                                    className={`block w-full ${
                                      isEditing && "bg-gray-100"
                                    }  mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                    disabled={isEditing}
                                  />
                                </div>

                                {/* Task Members */}
                                <div className="col-span-6 sm:col-span-3 md:col-span-2 lg:col-span-2">
                                  <label
                                    htmlFor="task_members"
                                    className="block text-sm font-medium text-gray-900"
                                  >
                                    TASK MEMBERS
                                  </label>

                                  <Select
                                    isMulti
                                    name="task_members"
                                    options={employeesList?.map((employee) => ({
                                      value: employee.id,
                                      label: employee.name,
                                    }))}
                                    value={employeesList
                                      ?.filter((employee) =>
                                        leadTaskDetails?.task_members?.includes(
                                          employee.id
                                        )
                                      )
                                      .map((employee) => ({
                                        value: employee.id,
                                        label: employee.name,
                                      }))}
                                    onChange={(selectedOptions) =>
                                      handleChangeForLeadTask({
                                        target: {
                                          name: "task_members",
                                          value: selectedOptions.map(
                                            (option) => option.value
                                          ),
                                        },
                                      })
                                    }
                                    className="w-full mt-2"
                                    isDisabled={isEditing}
                                    classNamePrefix="select"
                                  />
                                  {requiredFields.task_members && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields.task_members}
                                    </p>
                                  )}
                                </div>

                                {/* Start Date */}
                              </div>

                              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-5">
                                {/* Expected Delivery Date */}
                                <div className="w-full">
                                  <label
                                    htmlFor="end_date"
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    START DATE
                                  </label>
                                  <input
                                    type="date"
                                    name="start_date"
                                    value={leadTaskDetails?.start_date}
                                    onChange={handleChangeForLeadTask}
                                    className={`block w-full ${
                                      isEditing && "bg-gray-100"
                                    }  mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                    disabled={isEditing}
                                  />
                                  {requiredFields.start_date && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields.start_date}
                                    </p>
                                  )}
                                </div>

                                <div className="w-full">
                                  <label className="block text-sm font-medium leading-6 text-gray-900">
                                    END DATE
                                    <span className="text-red-600">*</span>
                                  </label>
                                  <div className="mt-2">
                                    <input
                                      name="end_date"
                                      type="date"
                                      value={leadTaskDetails?.end_date}
                                      onChange={handleChangeForLeadTask}
                                      placeholder="PHONE"
                                      className={`block w-full ${
                                        isEditing && "bg-gray-100"
                                      }  mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                      disabled={isEditing}
                                    />
                                  </div>
                                  {requiredFields.end_date && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields.end_date}
                                    </p>
                                  )}
                                </div>
                                <div className="w-full">
                                  <label
                                    htmlFor="expected_delivery_date"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    PRIORITY
                                  </label>
                                  <select
                                    name="priority"
                                    value={leadTaskDetails?.priority || ""}
                                    onChange={handleChangeForLeadTask}
                                    className={`block w-full ${
                                      isEditing && "bg-gray-100"
                                    }  mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                    disabled={isEditing}
                                  >
                                    <option value="" disabled>
                                      Select Status
                                    </option>
                                    {priority.map((prior) => (
                                      <option key={prior.id} value={prior.id}>
                                        {prior.name}
                                      </option>
                                    ))}
                                  </select>

                                  {/* <select
                                      name="priority"
                                      value={leadTaskDetails?.priority || ""}
                                      onChange={handleChangeForLeadTask}
                                       className={`block w-full ${
                                          isEditing && "bg-gray-100"
                                        }  mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                        disabled={isEditing}
                                    >
                                      <option value="" disabled>
                                        Select Priority Type
                                      </option>
                                      <option value="1" className="text-blue">
                                        Low
                                      </option>
                                      <option value="2">Medium</option>
                                      <option value="3">High</option>
                                      <option value="4">Urgent</option>
                                    </select>
                                    {requiredFields.lead_source_id && (
                                      <p className="mt-1 text-sm text-red-600">
                                        {requiredFields.lead_source_id}
                                      </p>
                                    )} */}
                                </div>

                                <div className="w-full ">
                                  <label
                                    htmlFor="expected_delivery_date"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Status
                                  </label>

                                  <Select
                                    name="task_status"
                                    options={taskStatusList?.map(
                                      (taskstatus) => ({
                                        value: taskstatus.id,
                                        label: taskstatus.name,
                                      })
                                    )}
                                    // value={
                                    //   taskStatusList
                                    //     ?.filter((taskstatus) => taskstatus.id === leadTaskDetails?.task_status)
                                    //     .map((taskstatus) => ({
                                    //       value: taskstatus.id,
                                    //       label: taskstatus.name,
                                    //     }))[0] || null
                                    // }
                                    value={
                                      taskStatusList
                                        ?.filter(
                                          (taskstatus) =>
                                            Number(taskstatus.id) ===
                                            Number(leadTaskDetails?.task_status)
                                        )
                                        .map((taskstatus) => ({
                                          value: taskstatus.id,
                                          label: taskstatus.name,
                                        }))[0] || null
                                    }
                                    onChange={(selectedOption) =>
                                      handleChange({
                                        target: {
                                          name: "task_status",
                                          value: selectedOption?.value,
                                        },
                                      })
                                    }
                                    className="w-full mt-2"
                                    isDisabled={isEditing}
                                    classNamePrefix="select"
                                  />
                                </div>

                                {/* Order Prefix */}

                                {/* Order No */}
                                {/* <div className="w-full">
                                    <label
                                      htmlFor="task_members"
                                      className="block text-sm font-medium leading-6 text-gray-900"
                                    >
                                      TASK MEMBERS
                                    </label>
                                    <Select
                                      isMulti
                                      name="task_members"
                                      options={employeesList.map((employee) => ({
                                        value: employee.id,
                                        label: employee.name,
                                      }))} // Convert employee list to react-select format
                                      value={employeesList
                                        .filter((employee) =>
                                          leadTaskDetails?.task_members?.includes(
                                            employee.id
                                          )
                                        )
                                        .map((employee) => ({
                                          value: employee.id,
                                          label: employee.name,
                                        }))}
                                      onChange={(selectedOptions) => {
                                        handleChangeForLeadTask({
                                          target: {
                                            name: "task_members",
                                            value: selectedOptions.map(
                                              (option) => option.value
                                            ),
                                          },
                                        });
                                      }}
                                      className="w-full mt-2"
                                      classNamePrefix="select"
                                    />
  
                                    {requiredFields.task_members && (
                                      <p className="mt-1 text-sm text-red-600">
                                        {requiredFields.task_members}
                                      </p>
                                    )}
                                  </div> */}

                                <div className="w-full">
                                  <label
                                    htmlFor="taskImageUpload"
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    FILE UPLOAD
                                  </label>
                                  <div className="mt-2">
                                    <label
                                      htmlFor="taskImageUpload"
                                      className="flex items-center justify-center w-full px-4 py-2 text-white bg-indigo-500 rounded-md shadow-md cursor-pointer hover:bg-indigo-700 focus:ring-2 focus:ring-indigo-500"
                                    >
                                      Upload File
                                    </label>
                                    <input
                                      id="taskImageUpload"
                                      name="taskImage"
                                      type="file"
                                      // multiple
                                      onChange={handleChangeForLeadTaskImage}
                                      className="hidden"
                                    />
                                  </div>

                                  {taskImage && (
                                    <p className="mt-1 text-sm text-green-600">
                                      {taskImage.name}
                                    </p>
                                  )}

                                  {requiredFields.leadTaskFile && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields.leadTaskFile}
                                    </p>
                                  )}
                                </div>
                              </div>

                              <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 gap-6 mt-4 sm:mt-5">
                                <div className="w-full">
                                  <div className="flex items-center space-x-2">
                                    <label
                                      htmlFor="task_description"
                                      className="block text-sm font-medium leading-6 text-gray-900"
                                    >
                                      TASK DESCRIPTION
                                    </label>
                                  </div>
                                  <ReactQuill
                                    theme="snow"
                                    value={leadTaskDetails?.task_description}
                                    onChange={(content) =>
                                      handleChangeForLeadTask({
                                        target: {
                                          name: "task_description",
                                          value: content,
                                        },
                                      })
                                    }
                                    modules={{ toolbar: toolbarOptions }}
                                    className="mt-2 bg-white rounded-md"
                                  />
                                  {requiredFields.position && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields.position}
                                    </p>
                                  )}
                                </div>
                              </div>
                              {/* Save Button */}
                              {/* {saveBtn === "save" ? (
                                  <div className="bg-white mt-6 flex justify-end">
                                    <button
                                      onClick={handleSubmitForLeadTask}
                                      className="flex justify-end py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                    >
                                      Save
                                    </button>
                                  </div>
                                ) : (
                                  <div className="bg-white mt-6">
                                    <button
                                      onClick={handleUpdateForLeadTask}
                                      className="flex justify-end py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                    >
                                      Update
                                    </button>
                                  </div>
                                )} */}
                              <div className="flex justify-end">
                                {saveBtn === "save" && saveBtnOpen ? (
                                  <div className="bg-white mt-6 flex justify-end">
                                    <button
                                      onClick={handleSubmitForLeadTask}
                                      className="flex justify-end py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                    >
                                      Save
                                    </button>
                                  </div>
                                ) : saveBtnOpen ? (
                                  <div className="bg-white mt-6">
                                    {/* <button
                                      onClick={handleUpdateForLeadTask}
                                      className="flex justify-end py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                    >
                                      Update
                                    </button> */}
                                    <UpdateConfirmation
                                      id_crypt={editTaskIdCrypt}
                                      apiType="lead_task"
                                      fetchClientData={fetchLeadTaskDatas}
                                      inputs={leadTaskDetails}
                                      dialogClose={setopenDialogBoxForLead}
                                    />
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </Dialog.Panel>
                </div>
              </div>
            </Dialog>
          )}
        </>
      )}
    </>
  );
}

export default LeadTaskCreate;
